import * as React from 'react';
import * as I18n from 'i18n-js';
import { CreditCard } from './selectable_credit_card_list_container';
import CreditCardIcon from './legacy/credit_card_icon';
import ReverifyCardContainer from './reverify_card_container';

interface IProps {
  creditCard: CreditCard;
  onClick: () => void;
  editPath?: string;
}

export default class SelectableCreditCard extends React.Component<IProps, null> {
  renderCardSummary() {
    const cardAbout = `${this.props.creditCard.cardType} ....${this.props.creditCard.last4}`;
    const expiryDate = `${this.props.creditCard.expirationMonth}/${this.props.creditCard.expirationYear}`;
    return (
      <div className="cc-details__card-info">
        <div className="cc-details__card-type">
          {cardAbout}
        </div>
        <div className="cc-details__expiration">
          {I18n.t('discovery.selectableCreditCardList.expiresOn', { date: expiryDate })}
        </div>
      </div>
    );
  }

  cardId(): string {
    return this.props.creditCard.id;
  }

  reverifyCardField() {
    if (!this.props.creditCard.isSelected || !this.props.creditCard.needsReverification) { return null; }
    return (
      <ReverifyCardContainer
        creditCardId={this.cardId()}
      />
    );
  }

  renderEditLink() {
    if (this.props.editPath) {
      return (
        <a
          href={this.props.editPath}
          className="boxed-list__action"
        >
          {I18n.t('discovery.selectableCreditCardList.edit')}
        </a>
      );
    }
  }

  render() {
    return (
      <li
        className="shop-onboarding__card"
        key={this.cardId()}
        onClick={this.props.onClick}
        id={`credit_card_${this.cardId()}`}
      >
        <input
          className="boxed-list__toggle"
          type="radio"
          checked={this.props.creditCard.isSelected}
          id={`credit_card_${this.props.creditCard.id}`}
          name="payment[credit_card_id]"
          value={this.cardId()}
          readOnly
        />
        <label
          className="boxed-list__item boxed-list__item--selectable"
          htmlFor={`credit_card_${this.props.creditCard.id}`}
        >
          <div className="cc-details">
            <div className="cc-details__card">
              <div className="cc-details__icon">
                <CreditCardIcon
                  cardType={this.props.creditCard.cardType}
                />
              </div>
              {this.renderCardSummary()}
            </div>
          </div>
          {this.renderEditLink()}
          {this.reverifyCardField()}
        </label>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/selectable_credit_card.tsx